import { PROVIDER_NAMES, FIN_PROVIDER_NAMES, FIN_ANALYTICS_NAMES, ANALYTICS_NAMES } from 'utils/constants';

import ProviderForm from 'pages/common/ProviderForm';
import ConsentForm from 'pages/Complaint/ConsentForm';
import SuccessPage from 'pages/common/SuccessPage';
import ComplaintDetailsForm from 'pages/Complaint/ComplaintDetailsForm';
import InsuredDetailsForm from 'pages/Complaint/InsuredDetails';
import FinYourDetailsForm from 'pages/FinancialHardship/YourDetailsForm';
import FinTellUsMoreForm from 'pages/FinancialHardship/TellUsMoreForm';
import FinInsuredDetailsForm from 'pages/FinancialHardship/InsuredDetailsForm';
import BreachYourDetailsForm from 'pages/Breach/YourDetailsForm';
import BreachTellUsMoreForm from 'pages/Breach/TellUsMoreForm';
import EmploymentForm from 'pages/FinancialHardship/EmploymentForm';
import IncomeExpenseForm from 'pages/FinancialHardship/IncomeExpenseForm';

export const complaintSteps = [
  { name: PROVIDER_NAMES.STEP1, analyticsName: ANALYTICS_NAMES.STEP1, component: ProviderForm },
  { name: PROVIDER_NAMES.STEP2, analyticsName: ANALYTICS_NAMES.STEP2, component: ConsentForm },
  { name: PROVIDER_NAMES.STEP3, analyticsName: ANALYTICS_NAMES.STEP3, component: InsuredDetailsForm },
  { name: PROVIDER_NAMES.STEP4, analyticsName: ANALYTICS_NAMES.STEP4, component: ComplaintDetailsForm },
  { name: PROVIDER_NAMES.STEP5, analyticsName: ANALYTICS_NAMES.STEP5, component: SuccessPage },
];

export const financialSteps = [
  { name: FIN_PROVIDER_NAMES.STEP1, analyticsName: FIN_ANALYTICS_NAMES.STEP1, component: ProviderForm },
  { name: FIN_PROVIDER_NAMES.STEP2, analyticsName: FIN_ANALYTICS_NAMES.STEP2, component: FinYourDetailsForm },
  { name: FIN_PROVIDER_NAMES.STEP3, analyticsName: FIN_ANALYTICS_NAMES.STEP3, component: FinInsuredDetailsForm },
  { name: FIN_PROVIDER_NAMES.STEP4, analyticsName: FIN_ANALYTICS_NAMES.STEP4, component: FinTellUsMoreForm },
  { name: FIN_PROVIDER_NAMES.STEP5, analyticsName: FIN_ANALYTICS_NAMES.STEP5, component: EmploymentForm },
  { name: FIN_PROVIDER_NAMES.STEP6, analyticsName: FIN_ANALYTICS_NAMES.STEP6, component: IncomeExpenseForm },
  { name: FIN_PROVIDER_NAMES.STEP7, analyticsName: FIN_ANALYTICS_NAMES.STEP7, component: SuccessPage },
];

export const breachSteps = [
  { name: PROVIDER_NAMES.STEP1, analyticsName: ANALYTICS_NAMES.STEP1, component: ProviderForm },
  { name: PROVIDER_NAMES.STEP2, analyticsName: ANALYTICS_NAMES.STEP2, component: BreachYourDetailsForm },
  { name: PROVIDER_NAMES.STEP4, analyticsName: ANALYTICS_NAMES.STEP4, component: BreachTellUsMoreForm },
  { name: PROVIDER_NAMES.STEP5, analyticsName: ANALYTICS_NAMES.STEP5, component: SuccessPage },
];
